import { useQuery } from "@tanstack/react-query";
import { isStaff } from "@cd/core";
import { api, type Me } from "./api";

/**
 * What the app offers this session. While staff view as someone it mirrors the worker's rules
 * (access.ts), which are what actually enforce them; this only keeps refused actions out of sight.
 */
export function capabilities(me: Me | undefined) {
  const v = me?.viewAs;
  return {
    viewAs: v,
    /** Create, change and delete their own dashboards and widgets. */
    write: !v || v.editing,
    /** Sharing, likes, publishing and unpublishing: never on someone else's behalf. */
    own: !v,
    /** Marketplace installs and updates: on someone's behalf only for super users, editing. */
    install: !v || (v.editing && v.tier === "super"),
    /** Staff-only features follow whoever is signed in, not who they're viewing as. */
    staff: v ? true : me ? isStaff(me) : false,
  };
}

export const useCapabilities = () =>
  capabilities(useQuery({ queryKey: ["me"], queryFn: api.me, retry: false, staleTime: Infinity }).data);
